import newsConstants    from './news.constants';
import newsInitialState from './news.state';

function newsReducer(state = newsInitialState, action) {
  switch (action.type) {
    case newsConstants.GET_NEWS_LIST_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case newsConstants.GET_NEWS_LIST_SUCCESS:
      state = {
        ...state,
        items:              action.items || newsInitialState.items,
        headItems:          action.headItems || newsInitialState.headItems,
        count:              +action.count || newsInitialState.count,
        loading:            false,
        initialStateLoaded: true,
      };
      break;

    case newsConstants.GET_NEWS_LIST_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case newsConstants.GET_NEWS_DETAIL_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case newsConstants.GET_NEWS_DETAIL_SUCCESS:
      state = {
        ...state,
        article:      {
          buttonLink:        action.buttonLink || newsInitialState.article.buttonLink,
          buttonName:        action.buttonName || newsInitialState.article.buttonName,
          contactButtonName: action.contactButtonName || newsInitialState.article.contactButtonName,
          newsId:            +action.newsId || newsInitialState.article.newsId,
          label:             action.label || newsInitialState.article.label,
          headImage:         action.headImage || newsInitialState.article.headImage,
          content:           action.content || newsInitialState.article.content,
          createdAt:         action.createdAt || newsInitialState.article.createdAt,
          createdAtIso:      action.createdAtIso || newsInitialState.article.createdAtIso,
          updatedAtIso:      action.updatedAtIso || newsInitialState.article.updatedAtIso,
          readingTime:       action.readingTime || newsInitialState.article.readingTime,
          relatedNews:       action.relatedNews || newsInitialState.article.relatedNews,
          meta:              {
            title: action.metaTitle || newsInitialState.article.meta.title,
            meta:  {
              keywords:    action.keywords || newsInitialState.article.meta.meta.keywords || '',
              description: action.description || newsInitialState.article.meta.meta.description || '',
              canonical:   action.canonical || newsInitialState.article.meta.meta.canonical || '',
            },
          },
        },
        loading:      false,
        detailLoaded: true,
      };
      break;

    case newsConstants.GET_NEWS_DETAIL_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case newsConstants.NEWS_SHOW_MORE_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case newsConstants.NEWS_SHOW_MORE_SUCCESS:
      state = {
        ...state,
        items:   [
          ...state.items,
          ...action.items,
        ],
        page:    action.page || state.page,
        loading: false,
      };
      break;

    case newsConstants.NEWS_SHOW_MORE_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case newsConstants.NEWS_DETAIL_RESET_INITIAL_STATE:
      state = {
        ...state,
        article:      newsInitialState.article,
        detailLoaded: newsInitialState.detailLoaded,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default newsReducer;